/*
 * Menu overlay
 *   - Toggles .menu-overlay visibility when .js-menu-toggle is clicked
 *   - Locks body scroll while open
 *   - Closes on Escape
 *   - Swaps the hamburger/close icon state via body/class
 */

const OPEN_CLASS = 'menu-is-open';

function open(body, toggle, overlay) {
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    body.classList.add(OPEN_CLASS);
    // Force reflow so the CSS transition runs from .menu-is-open being added.
    requestAnimationFrame(() => overlay.classList.add('is-open'));
}

function close(body, toggle, overlay) {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    body.classList.remove(OPEN_CLASS);
    // Hide after the transition ends so it's removed from the tab order.
    setTimeout(() => {
        if ( ! overlay.classList.contains('is-open') ) overlay.hidden = true;
    }, 400);
}

/*
 * Measure the header pill + hamburger cluster and pipe its left + right
 * viewport offsets into CSS custom properties so the overlay panel can
 * align exactly: panel left edge = pill left edge, panel right edge =
 * hamburger right edge. Re-runs on resize.
 */
function syncOverlayBounds(overlay, toggle) {
    const pill   = document.querySelector('.header__pill');
    const anchor = pill && getComputedStyle(pill).display !== 'none' ? pill : toggle;
    const left   = anchor.getBoundingClientRect().left;
    const right  = window.innerWidth - toggle.getBoundingClientRect().right;
    overlay.style.setProperty('--menu-overlay-left',  `${Math.max(0, left)}px`);
    overlay.style.setProperty('--menu-overlay-right', `${Math.max(0, right)}px`);
}

export function initMenuOverlay() {
    const toggle  = document.querySelector('.js-menu-toggle');
    const overlay = document.querySelector('.js-menu-overlay');
    if ( ! toggle || ! overlay ) return;

    const body = document.body;

    syncOverlayBounds(overlay, toggle);
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => syncOverlayBounds(overlay, toggle), 100);
    });

    toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        // Re-measure on open in case fonts/layout shifted since init.
        if ( ! isOpen ) syncOverlayBounds(overlay, toggle);
        isOpen ? close(body, toggle, overlay) : open(body, toggle, overlay);
    });

    document.addEventListener('keydown', (e) => {
        if ( e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true' ) {
            close(body, toggle, overlay);
        }
    });

    // Close when a link inside the overlay is clicked (so internal anchors work).
    overlay.addEventListener('click', (e) => {
        const link = e.target.closest('a[href]');
        if ( link ) close(body, toggle, overlay);
    });
}
